export function isFrame(): boolean {
  return window.self !== window.top;
}
